import {ReactElement, ChangeEvent, useMemo, ReactNode} from 'react';
import classNames from 'classnames';

interface CheckboxFieldProps {
  name: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  swithType?: '' | 'round';
  children?: ReactNode | ReactNode[];
  error?: string;
}

export default function ToggleSwitchField({
  name,
  checked,
  onChange,
  swithType = 'round',
  children,
  error,
}: CheckboxFieldProps): ReactElement {
  const hasError = useMemo(() => !!error, [error]);
  return (
    <>
      <label className="switch">
        <input
          type="checkbox"
          name={name}
          id={`id-${name}`}
          checked={checked}
          onChange={onChange}
        />
        <span className={classNames('slider', swithType)} />
      </label>
      <div className="toggle-switch-row__text">
        <label htmlFor={`id-${name}`}>{children}</label>
        {hasError && <p className="error-msg">{error}</p>}
      </div>
    </>
  );
}
